/**
 *
 * @param {Element} root la modal
 * @param {Element} lastFocusableElement Paramètre optionnel, permet de cibler un element en particulier pour lequel le focus reviendra au début
 * @description Naviguer au clavier dans la modal
 */
const keyboardNavigation = (root: HTMLElement, lastFocusableElement: Element = null) => {
	const focusableElements =
		'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	const firstFocusableElement = root.querySelectorAll(focusableElements)[0];
	const focusableContent = root.querySelectorAll(focusableElements);
	const getFirstFocus = firstFocusableElement as HTMLElement;
	if (!lastFocusableElement) {
		lastFocusableElement = focusableContent[focusableContent.length - 1];
	}

	document.addEventListener('keydown', function (e) {
		const isTabPressed = e.key === 'Tab';

		if (!isTabPressed) {
			return;
		}
		if (e.shiftKey) {
			// if shift key pressed for shift + tab combination
			const getlastFocus = lastFocusableElement as HTMLElement;

			if (document.activeElement === firstFocusableElement) {
				getlastFocus.focus(); // add focus for the last focusable element
				e.preventDefault();
			}
		} else {
			// if tab key is pressed
			if (document.activeElement === lastFocusableElement) {

				// if focused has reached to last focusable element then focus first focusable element after pressing tab
				getFirstFocus.focus(); // add focus for the first focusable element
				e.preventDefault();
			}
		}
	});

	getFirstFocus.focus();
};
